import React from 'react';
import { StyleSheet, View } from 'react-native';
const html = require('../../../../../../applications/beacon/assets/html/ToU.html');
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default function ToU() {
    return (<View style={styles.container}>
      <div dangerouslySetInnerHTML={{ __html: html }}/>
    </View>);
}
//# sourceMappingURL=ToU.web.js.map